import React, { useState, useEffect } from 'react';

// 👇 1. Añadimos el prop onScheduleCancelled
const Schedules = ({ isOpen, onClose, onScheduleCancelled }) => {
    const [schedules, setSchedules] = useState([]);

    const fetchSchedules = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${process.env.REACT_APP_API_URL}/schedules`, {
                headers: { 'x-access-token': token }
            });
            if (res.ok) {
                const data = await res.json();
                setSchedules(data);
            }
        } catch (e) {
            console.error("Error fetching schedules:", e);
        }
    };

    useEffect(() => {
        if (isOpen) {
            fetchSchedules();
            const interval = setInterval(fetchSchedules, 3000); 
            return () => clearInterval(interval);
        }
    }, [isOpen]);

    const handleCancel = async (ident) => {
        if (!window.confirm(`Abort scheduled mission for device ${ident}?`)) return;

        try {
            const token = localStorage.getItem('token');
            const userEmail = localStorage.getItem('email') || "admin@admin.com";
            
            const res = await fetch(`${process.env.REACT_APP_API_URL}/action`, {
                method: 'POST',
                headers: { 'x-access-token': token, 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    ident: ident, 
                    type: "action", 
                    payload: { target: "spoofing", action: "cancel_schedule", user: userEmail } 
                })
            });
            
            if (res.ok) {
                fetchSchedules();
                // 👇 2. AVISAMOS AL MAPA DE QUE ESTE DRON SE HA CANCELADO
                if (onScheduleCancelled) onScheduleCancelled(ident);
            }
        } catch (e) {
            console.error("Error aborting schedule:", e);
        }
    }

    return (
        <div className={`alerts-page-wrapper ${isOpen ? 'open' : ''}`}>
            <div className="alerts-header">
                <h2 className="alerts-title">ACTIVE SCHEDULES</h2>
                <button className="btn-close-alerts" onClick={onClose}>
                    <i className="fa-solid fa-times"></i>
                </button>
            </div>
            
            <div className="logs-grid">
                {schedules.length === 0 ? (
                    <div style={{color: '#888', textAlign: 'center', marginTop: '40px', fontFamily: 'monospace', letterSpacing: '1px'}}>
                        NO SCHEDULED MISSIONS
                    </div>
                ) : (
                    schedules.map((sch, i) => {
                        const dateObj = new Date(sch.scheduledTime);
                        return (
                            <div key={i} className="asset-card" style={{ borderColor: '#00bcd4', boxShadow: '0 0 10px rgba(0, 188, 212, 0.2)'}}>
                                <div className="asset-header">
                                    <span className="asset-id">{sch.ident}</span>
                                    <span className="tactical-badge active" style={{borderColor: '#00bcd4', color: '#00bcd4', background: 'rgba(0,188,212,0.1)'}}>
                                        {sch.params?.tacticalProfile || 'CUSTOM'}
                                    </span>
                                </div>
                                <div className="tunnel-info" style={{marginTop: '10px'}}>
                                    <span><strong>H-HOUR:</strong> {dateObj.toLocaleString()}</span>
                                    <span><strong>DURATION:</strong> {sch.scheduledDuration ? `${sch.scheduledDuration} MIN` : '∞ (INFINITE)'}</span>
                                    <span><strong>OPERATOR:</strong> {sch.user}</span>
                                    {sch.params?.spoofingLatitude && (
                                        <span style={{color: '#ff3333'}}><strong>TGT COORD:</strong> {sch.params.spoofingLatitude}, {sch.params.spoofingLongitude}</span>
                                    )}
                                </div>
                                
                                <button 
                                    className="btn-pill btn-armed-cancel" 
                                    style={{width: '100%', height: '35px', marginTop: '15px', animation: 'none'}} 
                                    onClick={() => handleCancel(sch.ident)}
                                >
                                    ABORT MISSION
                                </button>
                            </div>
                        )
                    })
                )}
            </div>
        </div>
    );
}

export default Schedules;